import { render, staticRenderFns } from "./procedimientos-evidencia.vue?vue&type=template&id=42fecfe0&scoped=true&"
import script from "./procedimientos-evidencia.vue?vue&type=script&lang=js&"
export * from "./procedimientos-evidencia.vue?vue&type=script&lang=js&"
import style0 from "./procedimientos-evidencia.vue?vue&type=style&index=0&id=42fecfe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fecfe0",
  null
  
)

export default component.exports